@if (loading()) {
  <div class="flex flex-column gap-4 p-6 align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    <span class="loadingText p-3">
      {{ "energy_tool.energy_data_export.loading" | translate }}
    </span>
  </div>
} @else {
  <form class="modalForm energyDataExportForm" [formGroup]="exportForm">
    <div class="flex flex-column gap-2 mb-3 g-col-1-3">
      <label for="energyDataExportKeys">{{ "energy_tool.energy_data_export.data" | translate }}</label>
      <p-multiSelect
        id="energyDataExportKeys"
        formControlName="keys"
        [options]="dataOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        styleClass="w-full"
        [showToggleAll]="false"
      >
        <ng-template let-values #selecteditems>
          @for (selectedOption of values; track getDataOptionValue(selectedOption)) {
            {{ getDataOptionLabelKey(selectedOption) | translate }}{{ $last ? "" : ", " }}
          }
        </ng-template>
        <ng-template let-option #item>
          {{ option.label | translate }}
        </ng-template>
      </p-multiSelect>
    </div>

    <fieldset class="timeSelection g-col-1-3">
      <legend>{{ "energy_tool.energy_data_export.time_window" | translate }}</legend>

      <div class="flex flex-column gap-3">
        <div class="periodRow">
          <div class="flex align-items-center">
            <p-radioButton name="dateMode" value="period" formControlName="dateMode" inputId="energyDataExportPeriod" />
            <label for="energyDataExportPeriod" class="ml-2">
              {{ "energy_tool.energy_data_export.period" | translate }}
            </label>
          </div>

          @if (exportForm.controls.dateMode.value === "period") {
            <div class="datePickerGroup">
              <div class="flex flex-column gap-1">
                <label for="energyDataExportStartDate">{{
                  "energy_tool.energy_data_export.start_date" | translate
                }}</label>
                <p-datePicker
                  id="energyDataExportStartDate"
                  formControlName="startDate"
                  [readonlyInput]="true"
                  dateFormat="dd.mm.yy"
                  appendTo="body"
                />
              </div>
              <div class="flex flex-column gap-1">
                <label for="energyDataExportEndDate">{{ "energy_tool.energy_data_export.end_date" | translate }}</label>
                <p-datePicker
                  id="energyDataExportEndDate"
                  formControlName="endDate"
                  [readonlyInput]="true"
                  dateFormat="dd.mm.yy"
                  appendTo="body"
                />
              </div>
            </div>
          }
        </div>

        <div class="quickSelectionRow">
          <div class="flex align-items-center">
            <p-radioButton
              name="dateMode"
              value="quick-selection"
              formControlName="dateMode"
              inputId="energyDataExportQuickSelection"
            />
            <label for="energyDataExportQuickSelection" class="ml-2">
              {{ "energy_tool.energy_data_export.quick_selection" | translate }}
            </label>
          </div>

          @if (exportForm.controls.dateMode.value === "quick-selection") {
            <p-select
              class="quickSelectionSelect"
              [options]="quickSelectionOptions"
              appendTo="body"
              formControlName="quickSelection"
            >
              <ng-template #selectedItem let-value>
                {{ value | translate }}
              </ng-template>
              <ng-template let-option #item>
                {{ option | translate }}
              </ng-template>
            </p-select>
          }
        </div>

        @if (exportForm.hasError("invalidDateRange")) {
          <span class="dateValidationMessage" aria-live="polite">
            {{ "energy_tool.energy_data_export.invalid_date_range" | translate }}
          </span>
        }
      </div>
    </fieldset>

    <div class="flex justify-content-end gap-2 dialogBtnGroup g-col-1-3">
      <app-button buttonText="common.cancel" color="grey" (click)="closeDialog()" />
      <app-button buttonText="common.save" color="primary" [disabled]="exportForm.invalid" (click)="startExport()" />
    </div>
  </form>
}
